export const environment = {
  production: false,
  api_endpoint: "",
  environment: "QAS",
  tooltip_header: "Ambiente de garantia da qualidade",
  environment_color_header: "#de8718",
  azure_enterprise_application: "bb4cd2d7-def2-4a6e-afab-326a409517d0",
  azure_ad_tenant_id: "c0945b70-f0ab-4396-baf1-4645f44ee549",
};
